import { render } from "./TestEmailsHeader.vue?vue&type=template&id=baa26d70&scoped=true"
import script from "./TestEmailsHeader.vue?vue&type=script&lang=js"
export * from "./TestEmailsHeader.vue?vue&type=script&lang=js"

import "./TestEmailsHeader.vue?vue&type=style&index=0&id=baa26d70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-baa26d70"]])

export default __exports__